var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usdt 1",
    clipPath: "url(#clip0_2402_2412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gradiants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tether (USDT)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "url(#paint0_linear_2402_2412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5909 21.9205V18.968H34.3084V14.3105H15.6659V18.968H22.4009V21.9205C16.7584 22.193 12.5234 23.3255 12.5234 24.6705C12.5234 26.0155 16.7534 27.153 22.4009 27.4205V37.1705H27.5909V27.4205C33.2334 27.1505 37.4684 26.018 37.4684 24.6705C37.4684 23.323 33.2459 22.193 27.5909 21.9205ZM24.9959 26.5605C18.8859 26.5605 13.9334 25.6155 13.9334 24.478C13.9334 23.5005 17.5409 22.678 22.3959 22.458V25.793C23.2309 25.8305 24.0984 25.853 24.9909 25.853C25.8834 25.853 26.7559 25.8305 27.5859 25.793V22.458C32.4409 22.678 36.0484 23.5005 36.0484 24.478C36.0584 25.628 31.1059 26.5605 24.9959 26.5605Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_2412",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68CCB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2402_2412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.ac261df33f9fc50a2505cbc11c265c35.svg";
export { ForwardRef as ReactComponent };